export const ProgramsSlideBtnContainerBgBlur = (): JSX.Element => (
  <div className="relative before:absolute before:right-[-1vw] w-full before:w-full h-full before:h-full before:bg-[rgba(255,255,255,20)] before:blur-[3vw]" />
)
